import { Dialog } from '@wg/wows-react-uikit';
import { PureComponent } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import styles from './ViewDialogs.scss';
import MultipleBuyDialog from '~/Components/Dialogs/MultipleBuyDialog/MultipleBuyDialog';
import StartBuyDialog from '~/Components/Dialogs/StartBuyDialog/StartBuyDialog';
import ErrorDialog from '~/Components/Dialogs/ErrorDialog/ErrorDialog';
import FinalDialog from '~/Components/Dialogs/FinalDialog/FinalDialog';
import RulesDialog from '~/Components/Dialogs/RulesDialog/RulesDialog';
import WelcomeDialog from '~/Components/Dialogs/WelcomeDialog/WelcomeDialog';
import BuyGoldDialog from '~/Components/Dialogs/BuyGoldDialog/BuyGoldDialog';
import ShipFeaturesDialog from '~/Components/Dialogs/ShipFeaturesDialog/ShipFeaturesDialog';
import Overlay from '~/Components/Overlay/Overlay';
import { Props } from '~/Containers/ContainerDialogs';
import preloaded from '~/preloaded';
import { RootState } from '~/store';

interface StateProps {
    boostersBg: string,
    finalBg: string,
    buyBg: string,
}

type ViewDialogsProps = StateProps & Props;

class ViewDialogs extends PureComponent<ViewDialogsProps> {
    closeStartBuyDialogBounded: () => void = this.closeStartBuyDialog.bind(this);

    closeStartBuyDialog() {
        if (!this.props.isBundleBuyDialogVisible) {
            this.props.closeStartBuyDialog();
        }
    }

    render() {
        const boostersBg = this.props.boostersBg ? `url("${this.props.boostersBg}")` : '';
        const finalBg = this.props.finalBg ? `url("${this.props.finalBg}")` : '';
        const buyBg = this.props.buyBg ? `url("${this.props.buyBg}")` : '';
        const isMainShipPreview = Number(this.props.mainRewardShipId) === this.props.shipFeaturesDialogShipId;

        return (
            <div className={styles.wrapper}>
                <Dialog
                    className={classnames(styles.autoBodyHeight, styles.rulesDialog, {
                        [styles.noAnimation]: this.props.noAnimation,
                    })}
                    content={<RulesDialog key={'RulesDialog'} />}
                    size={'worship'}
                    isOverlay={false}
                    isVisible={this.props.isRulesDialogOpen && !this.props.isShipFeaturesDialogVisible}
                    hideDialog={this.props.closeRulesDialog}
                />
                <Dialog
                    className={classnames(styles.multipleBuyDialog, {
                        [styles.multipleBuyDialog]: true,
                        [styles.noAnimation]: this.props.noAnimation,
                    })}
                    content={<MultipleBuyDialog key={'MultipleBuyDialog'} />}
                    size={'worship'}
                    isOverlay={false}
                    isVisible={this.props.isMultipleBuyDialogVisible}
                    hideDialog={this.props.closeMultipleBuyDialog}
                    overlayBackground={buyBg}
                />
                <Dialog
                    className={classnames(styles.startBuyDialog, {
                        [styles[`startBuyDialog-${preloaded.settings.realm}`]]: true,
                        [styles.noAnimation]: this.props.noAnimation,
                    })}
                    content={<StartBuyDialog key={'StartBuyDialog'} />}
                    size={'worship'}
                    isOverlay={false}
                    isVisible={this.props.isStartBuyDialogVisible}
                    hideDialog={this.closeStartBuyDialogBounded}
                    overlayBackground={boostersBg}
                />
                <Dialog
                    className={classnames({
                        [styles.noAnimation]: this.props.noAnimation,
                    })}
                    content={<ErrorDialog key={'ErrorDialog'} />}
                    size={'worship'}
                    isOverlay={false}
                    isVisible={this.props.isErrorDialogOpen}
                    hideDialog={this.props.closeErrorDialog}
                />
                <Dialog
                    className={classnames(styles.finalDialog, {
                        [styles.noAnimation]: this.props.noAnimation,
                    })}
                    content={<FinalDialog key={'FinalDialog'} />}
                    size={'overlay'}
                    isOverlay={false}
                    isVisible={this.props.isFinalDialogOpen}
                    hideDialog={this.props.closeFinalDialog}
                    overlayBackground={finalBg}
                />
                <Overlay isVisible={this.props.isOverlayVisible} hide={this.props.hideOverlay} />
                <WelcomeDialog
                    isVisible={this.props.isWelcomeDialogOpen && !this.props.isShipFeaturesDialogVisible}
                    hide={this.props.closeWelcomeDialog}
                />
                <BuyGoldDialog />
                {this.props.isShipFeaturesDialogVisible && this.props.shipFeaturesDialogShipId && (
                    <ShipFeaturesDialog
                        shipId={this.props.shipFeaturesDialogShipId}
                        isMainShip={isMainShipPreview}
                        isVisible={this.props.isShipFeaturesDialogVisible}
                        hide={this.props.closeShipFeaturesDialog}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: RootState): StateProps => ({
    boostersBg: state.app.kitBackgrounds?.[0] || '',
    finalBg: state.app.congratulationBackground || '',
    buyBg: state.app.purchaseConfirmationBackground || '',
});

export default connect(mapStateToProps)(ViewDialogs);
